import { Portrait } from '../../utils/editorReactIcons';
export { Portrait };
export default Portrait;
